'use client';

import {
  memo,
} from 'react';

import { useRouter } from 'next/navigation';

import { routes } from '@/features/v2/constants/routes';
import PromotionsCarousel from '@/features/v2/home/components/HeaderPublic/components/PromotionCarousel';
import core from '@/features/v2/home/components/localization/core';
import Header from '@/features/v2/shared/Header/Header';
import { cn } from '@/lib/utils';
import { userUIStore } from '@/stores/userUIStore';

import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

const image = 'https://secrzaapg5nnoosz.public.blob.vercel-storage.com/hondubet/ui/home/bghomePublic.webp';

const bannerImages = [
  {
    src: 'https://secrzaapg5nnoosz.public.blob.vercel-storage.com/powerbet/ui/home/soccerBannerFull.webp',
    position: 'object-[center_30%]',
  },
  {
    src: 'https://secrzaapg5nnoosz.public.blob.vercel-storage.com/powerbet/ui/home/basketBannerFull.webp',
    position: 'object-[center_15%]', 
  },
  {
    src: 'https://secrzaapg5nnoosz.public.blob.vercel-storage.com/powerbet/ui/home/towerBannerFull.webp',
    position: 'object-center', 
  },
];

const HeaderPublic = memo(() => {
  const router = useRouter();
  const { isSidebarOpen } = userUIStore();

  return (
    <section>
      <Header
        image={image}
        isVideo
        loopVideoProps={{ images: bannerImages }}
      >
        <div
          className={cn(
            'md:mt-24 md:ml-36 md:w-[60%] z-20',
            isSidebarOpen ? 'md:ml-60 mr-2' : 'md:ml-20',
          )}
        >
          <h1 className="text-hwhite text-4xl md:text-5xl font-title font-bold ">
            {core.public.title}
          </h1>

          <p className="text-hwhite text-lg md:text-xl font-text z-20 px-4 mt-3 font-normal leading-tight md:max-w-xl md:mx-auto">
            {core.public.description}{' '}
            <span className="font-semibold text-primary-500">
              {core.public.span1}
            </span>{' '}
            {core.public.description2}{' '}
            <span className="font-semibold text-primary-500">
              {core.public.span2}
            </span>
          </p>

          <div className="flex justify-center my-4 max-w-md mx-auto">
            <HButton
              label={core.public.button}
              size="medium"
              mode="secondary"
              disabled={false}
              onPress={() => { return router.push(routes.REGISTER); }}
              aria-label="Unirse ahora a Powerbet"
              fat
              withShadow
            />
          </div>
        </div>
      </Header>

      <section
        className={cn(
          'mx-auto flex justify-center md:mt-10',
          isSidebarOpen ? 'md:ml-60 mr-2' : 'md:ml-20',
        )}
        aria-label="Promociones destacadas"
      >
        <PromotionsCarousel />
      </section>
    </section>
  );
});

export default HeaderPublic;